import { Button } from '@devfolioco/genesis';
import { connect } from 'react-redux';
import React from 'react';

import Tooltip from 'components/Tooltip';

import { ACTION_STATUS as STATUS } from '../../../constants';

/**
 * The submit button.
 * In the sample mode, display the submit with a persistant toolitp.
 */
const Submit = React.memo(({ sample, loading, disabled }) => {
  const QuestionButton = () => (
    <Button type="submit" size="large" style={{ width: 280, marginRight: 16 }} disabled={disabled} loading={loading}>
      Submit
    </Button>
  );

  if (sample) {
    return (
      <Tooltip visible placement="right" data={() => <>Once done, click submit to move to the next question.</>}>
        {() => <QuestionButton />}
      </Tooltip>
    );
  }

  return <QuestionButton />;
});

const mapStateToProps = ({ quiz }) => {
  const { submitResponse, submitSkip, submitTimeout, submitSampleResponse } = quiz.status;

  return {
    loading:
      submitResponse !== STATUS.READY ||
      submitSkip !== STATUS.READY ||
      submitTimeout !== STATUS.READY ||
      submitSampleResponse !== STATUS.READY,
  };
};

export default connect(mapStateToProps)(Submit);
